module.exports = __webpack_public_path__ + "static/media/horseTypeIcon.de161ca6.svg";